import service from "./service";
import { i18n } from "../../i18n";

const state = {
  table: "pokojni",
  query: "",
  expanded: true,
  columns: [
    {
      label: i18n.t("deceased.person"),
      field: "pokojni"
    },
    {
      label: i18n.t("deceased.show"),
      field: "actions"
    }
  ],
  rows: []
};

const getters = {};

const mutations = {
  setQuery(state, query) {
    state.query = query;
  },
  setRows(state, rows) {
    state.rows = rows;
  },
  reset(state) {
    state.rows = [];
  },
  toggle(state, expanded) {
    state.expanded = expanded;
  }
};

const actions = {
  async get(context, query) {
    context.commit("setQuery", query);
    const table = context.state.table;

    return service
      .get(table, query)
      .then(data => {
        context.commit("setRows", data.data);
      })
      .catch(() => {
        context.commit("reset");
      });
  },
  reset(context) {
    context.commit("reset");
  },

  toggle(context, expand) {
    context.commit("toggle", expand);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
